import { isWebUrl, type LinkConfig } from "@ronin/contracts";
import { cn, Tooltip } from "@ronin/ui";
import { LinkIcon } from "./link-icon.js";

const row = "flex h-full min-w-0 items-center gap-3 px-3";

/** spec12 FR7: icon | name. The name and icon only, as a plain row. */
export function LinkContent({ config }: { config: LinkConfig }) {
  return (
    <>
      <LinkIcon icon={config.icon} className="size-6 text-secondary-foreground" />
      <span className="min-w-0 flex-1 truncate text-sm font-medium text-foreground">
        {config.name}
      </span>
    </>
  );
}

/**
 * The whole tile opens the link: in a new tab without opener or referrer (the Android app
 * hands it to the system browser). The scheme is checked again before rendering.
 */
export function LinkTile({ config }: { config: LinkConfig }) {
  if (!isWebUrl(config.url)) {
    return (
      <Tooltip content="This address cannot be opened">
        <span className={cn(row, "opacity-60")}>
          <LinkContent config={config} />
        </span>
      </Tooltip>
    );
  }
  return (
    <Tooltip content={config.url}>
      <a
        href={config.url}
        target="_blank"
        rel="noopener noreferrer"
        className={cn(
          row,
          "group focus-visible:outline-2 focus-visible:-outline-offset-2 focus-visible:outline-ring [&_svg]:transition-colors [&_svg]:duration-150 hover:[&_svg]:text-brand",
        )}
      >
        <LinkContent config={config} />
      </a>
    </Tooltip>
  );
}
